export default __webpack_public_path__ + "static/media/ground-ladder-test.214d5a23.webp";